import script from "./ResponseError.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponseError.vue?vue&type=script&setup=true&lang=js"

import "./ResponseError.vue?vue&type=style&index=0&id=bb940ab8&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\edb_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb940ab8"]])

export default __exports__